<app-application-requests-table [application]="application" [operationType]="'INPUT'"></app-application-requests-table>
<app-application-requests-table [application]="application" [operationType]="'OUTPUT'"></app-application-requests-table>

